import {
  evaluateConditionalJumpTarget,
  normalizeConditionalTargetCheckinIndexes,
  normalizeConditionalTargetConditionType
} from '@/utils/act004-user-form-fields'

export function normalizeBgOverlayDisplayOrder(raw) {
  const n = parseInt(raw, 10)
  return Number.isFinite(n) ? n : 0
}

export function normalizeBgOverlayConditionalRule(rule) {
  if (!rule || typeof rule !== 'object') return null
  const conditionType = normalizeConditionalTargetConditionType(rule.conditionType)
  const checkinIndexes = normalizeConditionalTargetCheckinIndexes(rule.checkinIndexes)
  const imageUrl = String(rule.imageUrl || '').trim()
  if (conditionType !== 'CHECKIN_POINTS' || !checkinIndexes.length || !imageUrl) return null
  return { conditionType, checkinIndexes, imageUrl }
}

export function normalizeBgOverlayConditionalRules(source) {
  const arr = Array.isArray(source) ? source : []
  return arr.map((r) => normalizeBgOverlayConditionalRule(r)).filter(Boolean)
}

export function resolveBgOverlayImageUrl(hotspot, evaluateOptions) {
  if (!hotspot || typeof hotspot !== 'object') return ''
  const rules = normalizeBgOverlayConditionalRules(hotspot.bgOverlayConditionalRules)
  const opts = evaluateOptions && typeof evaluateOptions === 'object' ? evaluateOptions : {}
  for (let i = 0; i < rules.length; i++) {
    const r = rules[i]
    if (
      evaluateConditionalJumpTarget({
        conditionType: r.conditionType,
        checkinIndexes: r.checkinIndexes,
        isCheckinPointDone: opts.isCheckinPointDone
      })
    ) {
      return r.imageUrl
    }
  }
  return String(hotspot.bgOverlayDefaultImage || '').trim()
}
